import Vue from 'vue'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
import vueCustomElement from 'vue-custom-element'
Vue.use(vueCustomElement)
import 'document-register-element/build/document-register-element'
import { config } from './config'
Vue.prototype.appConfig = config
Vue.config.productionTip = false
Vue.use(BootstrapVue)

 Vue.customElement('vue-widget', App)

/*
new Vue({
  render: h => h(App),
}).$mount('#app')

*/
